import { render } from "./GameBtns.vue?vue&type=template&id=d68de126&scoped=true"
import script from "./GameBtns.vue?vue&type=script&lang=js"
export * from "./GameBtns.vue?vue&type=script&lang=js"

import "./GameBtns.vue?vue&type=style&index=0&id=d68de126&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d68de126"]])

export default __exports__